import styled, { css } from 'styled-components';
import { Link } from 'src/components';

export const DropdownOption = styled(Link)(
  ({ theme }) => css`
    display: block;
    padding: ${theme.sz.s1} ${theme.sz.s4};
    color: ${theme.co.secondary0};
    ${theme.typography.heading.desktop.xxxs}
    text-decoration: none;
    transition: all 0.5s ease;

    &:hover {
      background-color: ${theme.co.information50};
      color: ${theme.co.neutral99};
    }
  `,
);

export const DropdownOptions = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s48};
    margin-top: ${theme.sz.s2};
    padding-top: ${theme.sz.s2};
    padding-bottom: ${theme.sz.s2};
    background-color: ${theme.co.neutral99};
    border-radius: ${theme.bo.small};
  `,
);
